export default __webpack_public_path__ + "static/media/463.dd35fbd3.png";